// import clsx from "clsx";
// import { MouseEventHandler } from "react";

import { ParsedLocation } from "~/../cms/prisma";
import { Pill } from "~/components/ui";
import type { useOperatingHours as UseOperatingHoursType } from "~/hooks/useOperatingHours";

const Tags = ({
  location,
  useOperatingHours,
  overrideOpenStatus,
}: {
  location: ParsedLocation;
  useOperatingHours: ReturnType<typeof UseOperatingHoursType>;
  overrideOpenStatus: string | false;
}) => {
  const { isOpen, closingInMinutes } = useOperatingHours;

  const TimeTag = () => {
    if (location.open247 === true && overrideOpenStatus === false)
      return <Pill text="Open 24/7" type="success" />;

    if (isOpen === false) return <Pill text="Closed" type="warning" />;

    if (closingInMinutes < 60 && overrideOpenStatus !== "open")
      return <Pill text="Closing Soon" type="warning" />;

    if (isOpen === true) return <Pill text="Open" type="success" />;
  };

  return (
    <ul className="flex flex-grow gap-1">
      {/* <li>{currentTime.toTimeString()}</li> */}
      <li>
        {location.type === "ed" && <Pill text="Emergency" />}
        {location.type === "upcc" && <Pill text="UPCC" />}
      </li>
      <li>
        <TimeTag />
      </li>
    </ul>
  );
};

export default Tags;
